/**
 * @file
 * Adds various classes depending on if some content is shown.
 */

(function ($, Drupal) {

  'use strict';


  Drupal.behaviors.conditional_content = {
    attach: function (context, settings) {

      // Article by category listing with events.
      if ($('#block-latest-events-by-category .wrapper').length) {
        $('.block-latest-articles-by-category').addClass('show-border');
      }

      // Hide empty open positions block.
      if ($('.block-open-positions-module').length) {
        if ($('.block-open-positions-module').children().length == 0) {
          $('.block-open-positions-module').parent().addClass('hide');
        }
      }

      // Hide empty hr events block.
      if ($('.block-views-blockcontent-highlights-events-latest-hr').length) {
        if ($('.block-views-blockcontent-highlights-events-latest-hr .view-content-highlights').children().length == 0) {
          $('.block-views-blockcontent-highlights-events-latest-hr').parent().addClass('hide');
        }
      }

    }
  };

})(jQuery, Drupal);
